package dev.danko.roblox_craft_ai.uikit.util

import kotlinx.browser.document

/**
 * Page scroll lock shared by dialogs and drawers. Counted, so overlapping overlays that close in any order
 * leave the page scrollable; restoring a saved value instead could put back another overlay's "hidden".
 */
object PageScrollLock {
    private var holders = 0

    fun acquire() {
        holders++
        document.body?.style?.setProperty("overflow", "hidden")
    }

    fun release() {
        holders = (holders - 1).coerceAtLeast(0)
        if (holders == 0) document.body?.style?.removeProperty("overflow")
    }

    /**
     * Drops a lock nobody holds. The static export snapshots pages with a dialog open, so the exported
     * <body> can arrive with overflow: hidden baked in and the page would never scroll.
     */
    fun reset() {
        holders = 0
        document.body?.style?.removeProperty("overflow")
    }
}
